/**
 * API CompagnonCPS
 * API pour le connecteur CompagnonCPS
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface CPXInfosPS { 
    /**
     * Type de la carte
     */
    cardType: CPXInfosPS.CardTypeEnum;
    /**
     * Identifiant National du PS
     */
    idNat: string;
    codeProfessionPS?: string;
    codeProfessionPF?: string;
    nomExercice: string;
    SpecOuRPPS?: string;
}
export namespace CPXInfosPS {
    export type CardTypeEnum = 'CPS' | 'CPA' | 'CPE' | 'CPF';
    export const CardTypeEnum = {
        Cps: 'CPS' as CardTypeEnum,
        Cpa: 'CPA' as CardTypeEnum,
        Cpe: 'CPE' as CardTypeEnum,
        Cpf: 'CPF' as CardTypeEnum
    };
}


